import { render, staticRenderFns } from "./FacilityDataDownload.vue?vue&type=template&id=67b5ca51&scoped=true"
import script from "./FacilityDataDownload.vue?vue&type=script&lang=js"
export * from "./FacilityDataDownload.vue?vue&type=script&lang=js"
import style0 from "./FacilityDataDownload.vue?vue&type=style&index=0&id=67b5ca51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5ca51",
  null
  
)

export default component.exports